module.exports = __webpack_public_path__ + "img/206.443da9d1.jpg";